import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.button`
  outline: none;
  cursor: normal;
  border: none;
  padding: 0;
  background: transparent;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
  line-height: 1em;
  display: flex;
  align-items: center;

  &:only-of-type {
    margin-left: auto;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    cursor: pointer;
  }
`;
